var map = {
	"./bchabc.svg": "8575",
	"./btc.svg": "cace",
	"./coins/AllImages/1ST.svg": "06fa",
	"./coins/AllImages/ABYSS.svg": "ba88",
	"./coins/AllImages/ADA-alt.svg": "33e5",
	"./coins/AllImages/ADA.svg": "12a4",
	"./coins/AllImages/ADC-alt.svg": "2230",
	"./coins/AllImages/ADC.svg": "4a38",
	"./coins/AllImages/ADX.svg": "c322",
	"./coins/AllImages/AE.svg": "997f",
	"./coins/AllImages/AEON-alt.svg": "a7eb",
	"./coins/AllImages/AEON.svg": "80ee",
	"./coins/AllImages/AION.svg": "15c7",
	"./coins/AllImages/AMP-alt.svg": "00ba",
	"./coins/AllImages/AMP.svg": "a093",
	"./coins/AllImages/ANC-alt.svg": "8073",
	"./coins/AllImages/ANC.svg": "bcf7",
	"./coins/AllImages/ANT.svg": "d4b2",
	"./coins/AllImages/ARCH-alt.svg": "40e9",
	"./coins/AllImages/ARCH.svg": "2f23",
	"./coins/AllImages/ARDR-alt.svg": "67c5",
	"./coins/AllImages/ARDR.svg": "570c",
	"./coins/AllImages/ARK-alt.svg": "bc6d",
	"./coins/AllImages/ARK.svg": "f6c2",
	"./coins/AllImages/ARN.svg": "1be6",
	"./coins/AllImages/AST.svg": "94e8",
	"./coins/AllImages/ATL.svg": "a982",
	"./coins/AllImages/AUR-alt.svg": "e805",
	"./coins/AllImages/AUR.svg": "c277",
	"./coins/AllImages/BANX-alt.svg": "0d23",
	"./coins/AllImages/BANX.svg": "ae89",
	"./coins/AllImages/BAT-alt.svg": "8699",
	"./coins/AllImages/BAT.svg": "81da",
	"./coins/AllImages/BAY-alt.svg": "0226",
	"./coins/AllImages/BAY.svg": "2bdc",
	"./coins/AllImages/BC-alt.svg": "48d7",
	"./coins/AllImages/BC.svg": "0ad1",
	"./coins/AllImages/BCD.svg": "0d8a",
	"./coins/AllImages/BCH-alt.svg": "74d9",
	"./coins/AllImages/BCH.svg": "8157",
	"./coins/AllImages/BCN-alt.svg": "ec91",
	"./coins/AllImages/BCN.svg": "ebc62",
	"./coins/AllImages/BCY.svg": "7a2f",
	"./coins/AllImages/BELA.svg": "0c06",
	"./coins/AllImages/BETR.svg": "6c46",
	"./coins/AllImages/BFT-alt.svg": "0fdd",
	"./coins/AllImages/BFT.svg": "01fc",
	"./coins/AllImages/BKX.svg": "5e0d",
	"./coins/AllImages/BLZ.svg": "f81a",
	"./coins/AllImages/BNB.svg": "0c2f",
	"./coins/AllImages/BNT.svg": "a37c",
	"./coins/AllImages/BRD.svg": "43ff",
	"./coins/AllImages/BRK-alt.svg": "0646",
	"./coins/AllImages/BRK.svg": "5150",
	"./coins/AllImages/BRX-alt.svg": "ed8b",
	"./coins/AllImages/BRX.svg": "ca4a",
	"./coins/AllImages/BSD-alt.svg": "6261",
	"./coins/AllImages/BSD.svg": "ee7c",
	"./coins/AllImages/BTA.svg": "e98a",
	"./coins/AllImages/BTC-alt.svg": "011c",
	"./coins/AllImages/BTC.svg": "d3a8",
	"./coins/AllImages/BTCD-alt.svg": "9dc4",
	"./coins/AllImages/BTCD.svg": "a26a",
	"./coins/AllImages/BTCP-alt.svg": "6211",
	"./coins/AllImages/BTCP.svg": "d406",
	"./coins/AllImages/BTG.svg": "ee0f",
	"./coins/AllImages/BTM-alt.svg": "6828",
	"./coins/AllImages/BTM.svg": "8659",
	"./coins/AllImages/BTS-alt.svg": "8716",
	"./coins/AllImages/BTS.svg": "2657",
	"./coins/AllImages/BURST.svg": "a250",
	"./coins/AllImages/CFI.svg": "7d34",
	"./coins/AllImages/CL.svg": "5242",
	"./coins/AllImages/CLAM-alt.svg": "6d16",
	"./coins/AllImages/CLAM.svg": "694e",
	"./coins/AllImages/CLOAK-alt.svg": "9c8e",
	"./coins/AllImages/CLOAK.svg": "d0ee",
	"./coins/AllImages/CMT.svg": "1721",
	"./coins/AllImages/CTR.svg": "e5b4",
	"./coins/AllImages/CVC-alt.svg": "711d",
	"./coins/AllImages/CVC.svg": "eb63",
	"./coins/AllImages/DAI.svg": "9b76",
	"./coins/AllImages/DAO-alt.svg": "cd1ca",
	"./coins/AllImages/DAO.svg": "f2a94",
	"./coins/AllImages/DAR.svg": "b4e5",
	"./coins/AllImages/DASH-alt.svg": "9d57",
	"./coins/AllImages/DASH.svg": "b9f9",
	"./coins/AllImages/DCN.svg": "1307",
	"./coins/AllImages/DCR-alt.svg": "2a08",
	"./coins/AllImages/DCR.svg": "b0a5",
	"./coins/AllImages/DCT-alt.svg": "aec9",
	"./coins/AllImages/DCT.svg": "bd3b",
	"./coins/AllImages/DENT.svg": "64fe",
	"./coins/AllImages/DGB-alt.svg": "84c0",
	"./coins/AllImages/DGB.svg": "804c",
	"./coins/AllImages/DGD.svg": "4362",
	"./coins/AllImages/DGX.svg": "806d",
	"./coins/AllImages/DMD-alt.svg": "c4e0",
	"./coins/AllImages/DMD.svg": "3d4f",
	"./coins/AllImages/DNT.svg": "254d",
	"./coins/AllImages/DOGE-alt.svg": "a72c",
	"./coins/AllImages/DOGE.svg": "c369",
	"./coins/AllImages/DSH.svg": "0b63",
	"./coins/AllImages/EDG.svg": "befe",
	"./coins/AllImages/ELF.svg": "2979",
	"./coins/AllImages/EMC-alt.svg": "949d",
	"./coins/AllImages/EMC.svg": "d8a4",
	"./coins/AllImages/EMC2-alt.svg": "b915",
	"./coins/AllImages/EMC2.svg": "6068",
	"./coins/AllImages/ENJ.svg": "c0c1",
	"./coins/AllImages/EOS-alt.svg": "6c707",
	"./coins/AllImages/EOS.svg": "3780",
	"./coins/AllImages/ERC-alt.svg": "98d7",
	"./coins/AllImages/ERC.svg": "9e46",
	"./coins/AllImages/ETC-alt.svg": "3341",
	"./coins/AllImages/ETC.svg": "02fc",
	"./coins/AllImages/ETH-alt.svg": "925f",
	"./coins/AllImages/ETH.svg": "a1d4",
	"./coins/AllImages/EURS.svg": "2018",
	"./coins/AllImages/EXP-alt.svg": "965f",
	"./coins/AllImages/EXP.svg": "632c",
	"./coins/AllImages/FC2-alt.svg": "b125",
	"./coins/AllImages/FC2.svg": "c482",
	"./coins/AllImages/FCN.svg": "56443",
	"./coins/AllImages/FCT-alt.svg": "6097",
	"./coins/AllImages/FCT.svg": "aa19",
	"./coins/AllImages/FLDC-alt.svg": "79b2",
	"./coins/AllImages/FLDC.svg": "a992",
	"./coins/AllImages/FLO-alt.svg": "1432",
	"./coins/AllImages/FLO.svg": "2a79",
	"./coins/AllImages/FRK-alt.svg": "a8b2",
	"./coins/AllImages/FRK.svg": "7d7d",
	"./coins/AllImages/FTC-alt.svg": "6f1b",
	"./coins/AllImages/FTC.svg": "3388",
	"./coins/AllImages/FUN.svg": "1624",
	"./coins/AllImages/GAME-alt.svg": "de52",
	"./coins/AllImages/GAME.svg": "cb82",
	"./coins/AllImages/GBG.svg": "db0b",
	"./coins/AllImages/GBYTE-alt.svg": "208f",
	"./coins/AllImages/GBYTE.svg": "bd1e",
	"./coins/AllImages/GDC-alt.svg": "b457",
	"./coins/AllImages/GDC.svg": "eaad",
	"./coins/AllImages/GEMZ-alt.svg": "9445",
	"./coins/AllImages/GEMZ.svg": "f39b",
	"./coins/AllImages/GLD-alt.svg": "be61",
	"./coins/AllImages/GLD.svg": "e2c7",
	"./coins/AllImages/GNO-alt.svg": "ed9e",
	"./coins/AllImages/GNO.svg": "b9d6",
	"./coins/AllImages/GNT-alt.svg": "9d65",
	"./coins/AllImages/GNT.svg": "a187",
	"./coins/AllImages/GOLOS-alt.svg": "898a",
	"./coins/AllImages/GOLOS.svg": "56ea",
	"./coins/AllImages/GRC-alt.svg": "a36d",
	"./coins/AllImages/GRC.svg": "4f87",
	"./coins/AllImages/GRS.svg": "ff12",
	"./coins/AllImages/GUP.svg": "a42e",
	"./coins/AllImages/GUSD.svg": "2571",
	"./coins/AllImages/HEAT-alt.svg": "c86a",
	"./coins/AllImages/HEAT.svg": "0898",
	"./coins/AllImages/HMQ.svg": "8672",
	"./coins/AllImages/HSR.svg": "264c",
	"./coins/AllImages/HUC-alt.svg": "1612",
	"./coins/AllImages/HUC.svg": "238d",
	"./coins/AllImages/ICN-alt.svg": "1e5ba",
	"./coins/AllImages/ICN.svg": "c651",
	"./coins/AllImages/ICX.svg": "a058",
	"./coins/AllImages/IFC-alt.svg": "e271",
	"./coins/AllImages/IFC.svg": "1c02",
	"./coins/AllImages/IGNIS.svg": "de94",
	"./coins/AllImages/INCNT-alt.svg": "478c",
	"./coins/AllImages/INCNT.svg": "7413",
	"./coins/AllImages/IOC-alt.svg": "acb1",
	"./coins/AllImages/IOC.svg": "1888",
	"./coins/AllImages/IOST.svg": "6f83",
	"./coins/AllImages/IOTA-alt.svg": "e028",
	"./coins/AllImages/IOTA.svg": "5d24",
	"./coins/AllImages/JBS-alt.svg": "8c27",
	"./coins/AllImages/JBS.svg": "8b33",
	"./coins/AllImages/KIN.svg": "7033",
	"./coins/AllImages/KMD-alt.svg": "1881",
	"./coins/AllImages/KMD.svg": "7acb",
	"./coins/AllImages/KNC.svg": "070cc",
	"./coins/AllImages/KOBO.svg": "e360",
	"./coins/AllImages/KORE-alt.svg": "6813",
	"./coins/AllImages/KORE.svg": "c243",
	"./coins/AllImages/LBC-alt.svg": "38f3",
	"./coins/AllImages/LBC.svg": "5772",
	"./coins/AllImages/LDOGE-alt.svg": "032b",
	"./coins/AllImages/LDOGE.svg": "893e",
	"./coins/AllImages/LINK.svg": "cb33",
	"./coins/AllImages/LRC.svg": "c36b",
	"./coins/AllImages/LSK-alt.svg": "99bb",
	"./coins/AllImages/LSK.svg": "a5da",
	"./coins/AllImages/LTC-alt.svg": "4c40",
	"./coins/AllImages/LTC.svg": "09bd",
	"./coins/AllImages/LUN.svg": "fa3b",
	"./coins/AllImages/MAID-alt.svg": "6ce8",
	"./coins/AllImages/MAID.svg": "c563",
	"./coins/AllImages/MARKS-alt.svg": "48fb",
	"./coins/AllImages/MARKS.svg": "723f",
	"./coins/AllImages/MCO-alt.svg": "ec3a",
	"./coins/AllImages/MCO.svg": "9660",
	"./coins/AllImages/MINT-alt.svg": "255a",
	"./coins/AllImages/MINT.svg": "8739",
	"./coins/AllImages/MITH.svg": "af3a",
	"./coins/AllImages/MKR.svg": "321f",
	"./coins/AllImages/MLN.svg": "a00c",
	"./coins/AllImages/MONA-alt.svg": "f8fd",
	"./coins/AllImages/MONA.svg": "50fc",
	"./coins/AllImages/MRC.svg": "ed5a",
	"./coins/AllImages/MSC-alt.svg": "292d0",
	"./coins/AllImages/MSC.svg": "761f",
	"./coins/AllImages/MTL-alt.svg": "ddc5",
	"./coins/AllImages/MTL.svg": "9a9d",
	"./coins/AllImages/MTR-alt.svg": "5391",
	"./coins/AllImages/MTR.svg": "e9f8",
	"./coins/AllImages/MUE-alt.svg": "a7ee",
	"./coins/AllImages/MUE.svg": "ec90",
	"./coins/AllImages/MYST-alt.svg": "7f54",
	"./coins/AllImages/MYST.svg": "ed5f",
	"./coins/AllImages/NAV-alt.svg": "1c027",
	"./coins/AllImages/NAV.svg": "c781",
	"./coins/AllImages/NBT.svg": "41f7",
	"./coins/AllImages/NEO-alt.svg": "f05b",
	"./coins/AllImages/NEO.svg": "224a",
	"./coins/AllImages/NEOS-alt.svg": "df50",
	"./coins/AllImages/NEOS.svg": "c22a",
	"./coins/AllImages/NEU-alt.svg": "2bdd",
	"./coins/AllImages/NEU.svg": "ef6a",
	"./coins/AllImages/NEXO.svg": "5384f",
	"./coins/AllImages/NGC.svg": "3f12",
	"./coins/AllImages/NLG-alt.svg": "931a",
	"./coins/AllImages/NLG.svg": "d62a",
	"./coins/AllImages/NMC-alt.svg": "973b",
	"./coins/AllImages/NMC.svg": "5c39",
	"./coins/AllImages/NMR.svg": "afd2",
	"./coins/AllImages/NOAH.svg": "fcf7",
	"./coins/AllImages/NOTE-alt.svg": "7a87",
	"./coins/AllImages/NOTE.svg": "d61b",
	"./coins/AllImages/NVC-alt.svg": "309d",
	"./coins/AllImages/NVC.svg": "b67b",
	"./coins/AllImages/NXT-alt.svg": "1cc1",
	"./coins/AllImages/NXT.svg": "7fc6",
	"./coins/AllImages/OK-alt.svg": "96e9",
	"./coins/AllImages/OK.svg": "2e23",
	"./coins/AllImages/OMG-alt.svg": "e215",
	"./coins/AllImages/OMG.svg": "9e69",
	"./coins/AllImages/OMNI-alt.svg": "c530",
	"./coins/AllImages/OMNI.svg": "08c0",
	"./coins/AllImages/ONT.svg": "bbdb",
	"./coins/AllImages/OPAL-alt.svg": "825e",
	"./coins/AllImages/OPAL.svg": "991d",
	"./coins/AllImages/PART-alt.svg": "f224",
	"./coins/AllImages/PART.svg": "3d53",
	"./coins/AllImages/PASC.svg": "355e",
	"./coins/AllImages/PAT.svg": "08fe",
	"./coins/AllImages/PAY.svg": "1eea",
	"./coins/AllImages/PIGGY-alt.svg": "bbce",
	"./coins/AllImages/PIGGY.svg": "8ad1",
	"./coins/AllImages/PINK-alt.svg": "aac8",
	"./coins/AllImages/PINK.svg": "685f",
	"./coins/AllImages/PIVX-alt.svg": "3bc4",
	"./coins/AllImages/PIVX.svg": "16b4",
	"./coins/AllImages/POLY.svg": "94e7",
	"./coins/AllImages/POT-alt.svg": "8655",
	"./coins/AllImages/POT.svg": "51e9",
	"./coins/AllImages/POWR.svg": "bd15",
	"./coins/AllImages/PPC-alt.svg": "f33f",
	"./coins/AllImages/PPC.svg": "ecc8",
	"./coins/AllImages/PPT.svg": "5c26",
	"./coins/AllImages/PROC.svg": "4694",
	"./coins/AllImages/PTOY.svg": "fe4c",
	"./coins/AllImages/QCN.svg": "9323",
	"./coins/AllImages/QRK-alt.svg": "c33f",
	"./coins/AllImages/QRK.svg": "7d88",
	"./coins/AllImages/QTUM-alt.svg": "6e7c",
	"./coins/AllImages/QTUM.svg": "0d07",
	"./coins/AllImages/R.svg": "8d78",
	"./coins/AllImages/RADS-alt.svg": "9c4b",
	"./coins/AllImages/RADS.svg": "96b4",
	"./coins/AllImages/RBIES-alt.svg": "c839",
	"./coins/AllImages/RBIES.svg": "09b8",
	"./coins/AllImages/RBT-alt.svg": "2a91",
	"./coins/AllImages/RBT.svg": "c3a5",
	"./coins/AllImages/RBY-alt.svg": "cae0",
	"./coins/AllImages/RBY.svg": "6075",
	"./coins/AllImages/RCN.svg": "eef6",
	"./coins/AllImages/RDD-alt.svg": "6701",
	"./coins/AllImages/RDD.svg": "791d",
	"./coins/AllImages/REP-alt.svg": "422d",
	"./coins/AllImages/REP.svg": "02e7",
	"./coins/AllImages/RHOC.svg": "3357",
	"./coins/AllImages/RIC-alt.svg": "e8e3",
	"./coins/AllImages/RIC.svg": "ece0",
	"./coins/AllImages/RISE-alt.svg": "b716",
	"./coins/AllImages/RISE.svg": "0b45",
	"./coins/AllImages/RLC.svg": "4c87",
	"./coins/AllImages/SALT-alt.svg": "148e",
	"./coins/AllImages/SALT.svg": "741e",
	"./coins/AllImages/SAR-alt.svg": "db8c",
	"./coins/AllImages/SAR.svg": "36ef",
	"./coins/AllImages/SBD.svg": "339d",
	"./coins/AllImages/SCOT-alt.svg": "5ff0",
	"./coins/AllImages/SCOT.svg": "6e95",
	"./coins/AllImages/SDC-alt.svg": "60df",
	"./coins/AllImages/SDC.svg": "43bd",
	"./coins/AllImages/SIA-alt.svg": "2eb0",
	"./coins/AllImages/SIA.svg": "4d8a",
	"./coins/AllImages/SJCX-alt.svg": "964b",
	"./coins/AllImages/SJCX.svg": "1610",
	"./coins/AllImages/SKIN.svg": "8d4eb",
	"./coins/AllImages/SLG-alt.svg": "cd64",
	"./coins/AllImages/SLG.svg": "e389",
	"./coins/AllImages/SLS-alt.svg": "afdd",
	"./coins/AllImages/SLS.svg": "1b18",
	"./coins/AllImages/SMART.svg": "6ec3",
	"./coins/AllImages/SNGLS.svg": "07ba",
	"./coins/AllImages/SNM.svg": "ba0c6",
	"./coins/AllImages/SNRG-alt.svg": "ad49",
	"./coins/AllImages/SNRG.svg": "d1a5",
	"./coins/AllImages/SNT.svg": "e4ac",
	"./coins/AllImages/START-alt.svg": "66f7",
	"./coins/AllImages/START.svg": "bb45",
	"./coins/AllImages/STEEM-alt.svg": "aa44",
	"./coins/AllImages/STEEM.svg": "3ee5",
	"./coins/AllImages/STORJ.svg": "2e42",
	"./coins/AllImages/STRAT-alt.svg": "1748",
	"./coins/AllImages/STRAT.svg": "3feb",
	"./coins/AllImages/STX.svg": "43eb",
	"./coins/AllImages/SWIFT-alt.svg": "305a",
	"./coins/AllImages/SWIFT.svg": "bda1",
	"./coins/AllImages/SWT.svg": "493d",
	"./coins/AllImages/SYNC-alt.svg": "db85",
	"./coins/AllImages/SYNC.svg": "7dc6",
	"./coins/AllImages/SYS-alt.svg": "3506",
	"./coins/AllImages/SYS.svg": "f97c",
	"./coins/AllImages/TEL.svg": "cff5",
	"./coins/AllImages/TIME.svg": "3707",
	"./coins/AllImages/TKN.svg": "86a4",
	"./coins/AllImages/TRIG-alt.svg": "a239",
	"./coins/AllImages/TRIG.svg": "4db3",
	"./coins/AllImages/TRST.svg": "82d0",
	"./coins/AllImages/TRX.svg": "4483",
	"./coins/AllImages/TUSD.svg": "677d",
	"./coins/AllImages/TX-alt.svg": "5db7",
	"./coins/AllImages/TX.svg": "4593",
	"./coins/AllImages/UBQ-alt.svg": "7e47",
	"./coins/AllImages/UBQ.svg": "2ae6",
	"./coins/AllImages/UNITY-alt.svg": "31d1",
	"./coins/AllImages/UNITY.svg": "9569",
	"./coins/AllImages/USDC.svg": "b5eb",
	"./coins/AllImages/USDT-alt.svg": "e303",
	"./coins/AllImages/USDT.svg": "3e42",
	"./coins/AllImages/USNBT.svg": "1ac7",
	"./coins/AllImages/VEN.svg": "9ae0",
	"./coins/AllImages/VIA-alt.svg": "15f7",
	"./coins/AllImages/VIA.svg": "7678",
	"./coins/AllImages/VIB.svg": "3894",
	"./coins/AllImages/VIOR-alt.svg": "1b8e",
	"./coins/AllImages/VIOR.svg": "046e",
	"./coins/AllImages/VNL-alt.svg": "46c6",
	"./coins/AllImages/VNL.svg": "a9d1",
	"./coins/AllImages/VPN-alt.svg": "170a",
	"./coins/AllImages/VPN.svg": "d036",
	"./coins/AllImages/VRC-alt.svg": "5823",
	"./coins/AllImages/VRC.svg": "3fe3",
	"./coins/AllImages/VTC-alt.svg": "d698",
	"./coins/AllImages/VTC.svg": "a1fe",
	"./coins/AllImages/WAVES-alt.svg": "4843",
	"./coins/AllImages/WAVES.svg": "954d",
	"./coins/AllImages/WAX.svg": "85ad",
	"./coins/AllImages/WINGS.svg": "24a8",
	"./coins/AllImages/WTC.svg": "2b2c",
	"./coins/AllImages/XAI-alt.svg": "9d00",
	"./coins/AllImages/XAI.svg": "745e",
	"./coins/AllImages/XAUR.svg": "d921",
	"./coins/AllImages/XBC.svg": "6074",
	"./coins/AllImages/XBS-alt.svg": "17c0",
	"./coins/AllImages/XBS.svg": "53f6",
	"./coins/AllImages/XCP-alt.svg": "91c4",
	"./coins/AllImages/XCP.svg": "ed70",
	"./coins/AllImages/XDN.svg": "4e3d",
	"./coins/AllImages/XEM-alt.svg": "a85f",
	"./coins/AllImages/XEM.svg": "bab6",
	"./coins/AllImages/XLM-alt.svg": "3d6e",
	"./coins/AllImages/XLM.svg": "ab24",
	"./coins/AllImages/XMO.svg": "fd54",
	"./coins/AllImages/XMR.svg": "c4a4",
	"./coins/AllImages/XMY.svg": "f2cb",
	"./coins/AllImages/XPM-alt.svg": "0d06",
	"./coins/AllImages/XPM.svg": "4f3d",
	"./coins/AllImages/XRP-alt.svg": "8fda",
	"./coins/AllImages/XRP.svg": "46ed",
	"./coins/AllImages/XTZ-alt.svg": "4bee",
	"./coins/AllImages/XTZ.svg": "92ad",
	"./coins/AllImages/XVC-alt.svg": "4ae6",
	"./coins/AllImages/XVC.svg": "7035",
	"./coins/AllImages/XVG-alt.svg": "d0f0",
	"./coins/AllImages/XVG.svg": "e873",
	"./coins/AllImages/XZC-alt.svg": "d576",
	"./coins/AllImages/XZC.svg": "1056",
	"./coins/AllImages/YBC-alt.svg": "0c96",
	"./coins/AllImages/YBC.svg": "36d7",
	"./coins/AllImages/ZAP.svg": "f41f",
	"./coins/AllImages/ZCL.svg": "4e57",
	"./coins/AllImages/ZEC-alt.svg": "04ab",
	"./coins/AllImages/ZEC.svg": "d64d",
	"./coins/AllImages/ZEIT-alt.svg": "47dd",
	"./coins/AllImages/ZEIT.svg": "ba5e",
	"./coins/AllImages/ZEN.svg": "46ce",
	"./coins/AllImages/ZIL.svg": "112e",
	"./coins/AllImages/ZRX-alt.svg": "2d0a",
	"./coins/AllImages/ZRX.svg": "ad45",
	"./coins/asFont/cryptocoins.svg": "3ce3",
	"./coins/asFont/cryptocoins.symbol.svg": "e0a3",
	"./eth.svg": "9165",
	"./ether.svg": "7f33",
	"./eur.svg": "49ea",
	"./gbp.svg": "eb3b",
	"./rep.svg": "138e",
	"./rop.svg": "a9df",
	"./usd.svg": "55e3",
	"./usdt.svg": "65fd",
	"./xdc.svg": "ab08",
	"./xrp.svg": "eaea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7cd9";